import { Component, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { stringify } from '@angular/compiler/src/util';
import { ElementRef } from '@angular/core';
import { AfterViewInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MasterRolePermission } from '../Models/master-role-permission';
import { MasterUser } from 'src/app/Models/master-user';
import { UserApiService } from 'src/app/user-api.service';
import { FormBuilder, FormGroup, AbstractControl, Validators } from '@angular/forms';
import { ConfirmedValidator } from './tchgpwd.validator';
import { ToasterService } from 'src/app/Shared/toaster.service';
import { Tchgpwd } from 'src/app/Models/tchgpwd';

@Component({
  selector: 'app-tchgpwd',
  templateUrl: './tchgpwd.component.html',
  styleUrls: ['./tchgpwd.component.css']
})
export class TchgpwdComponent implements OnInit {
  userForm: FormGroup;
  selectedUser: MasterUser = new MasterUser();
  selectedTchgpwd: Tchgpwd = new Tchgpwd();  

  // Properties that store paths to FormControls makes our template less verbose
  // oldpassword: AbstractControl;
  password: AbstractControl;
  cpassword: AbstractControl;

   //constructor() { }
  constructor(private toasterService: ToasterService, private elementRef: ElementRef, private router: Router, private userApi: UserApiService, private formBuilder: FormBuilder) { }

  PASSWORD_WILL_EXPIRE: string = '';

  ngOnInit(): void {  
    
    var token = sessionStorage.getItem('token');
    if (token == null) {
      this.router.navigateByUrl('/');
      return;
    }
    if (parseInt(sessionStorage.getItem('EXPIRY_COUNT')) <= 5) {
      this.PASSWORD_WILL_EXPIRE = 'Password will expiry in ' + sessionStorage.getItem('EXPIRY_COUNT') + ' Days';
    }
    
    var tmp = sessionStorage.getItem('tmp');
    if (tmp) {
       this.InitializeForm();
   }
   else
   {
     this.router.navigateByUrl('/');
       return;
   }

  }

  InitializeForm() {
    this.userForm = this.formBuilder.group(
      {
        // oldpassword: ['', [Validators.required]],
        password: ['', [Validators.required]],
        cpassword: ['', [Validators.required]]

      },
      {
        //validator: ConfirmedValidator("password", "cpassword")
        // Here we create validators to be used for the group as a whole
        validator: Validators.compose([
          // ConfirmedValidator.newIsNotOld, 
          ConfirmedValidator.newMatchesConfirm
          
      ])
      }
    );
    // this.oldpassword = this.userForm.controls['oldpassword'];
        this.password = this.userForm.controls['password'];
        this.cpassword = this.userForm.controls['cpassword'];
  }

  HasViewPermission(name: string) {
    return sessionStorage.getItem("ROLE_PERMISSIONS").toString().indexOf(name) >= 0;
  }

  get formUser() { return this.userForm.controls; };

  Submit(password: string, cpassword: string){
    if(password == ''){      
      alert('New Password is Required');
    }
    else{
    if(cpassword == ''){      
      alert('Confirm Password is Required');
    }
    else{
      if (password !== cpassword) {
        alert('New Password and Confirm Password does not match');
    }
    else{
      if (this.MeasureStrength(password)<70) {
        alert('Password must contain minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character');
      }
      else{
    this.selectedUser = new MasterUser();
    this.selectedTchgpwd = new Tchgpwd();
    //sessionStorage.setItem('token', this.selectedUser.USER_ID + ''); 
    var token = sessionStorage.getItem('token');
    if (token != null) {
      
    // this.selectedUser.LOGIN_PASSWORD = oldpassword;
    this.selectedTchgpwd.USER_ID = token;
    this.selectedTchgpwd.LOGIN_PASSWORD = password;
    //this.selectedTchgpwd.ConfirmPassword = cpassword;
    this.userApi.changeUserTempPwd(this.selectedTchgpwd).subscribe((resp) => {   

      if (resp.status == 0) {
        this.toasterService.Success(resp.Status_Msg, 'Info');
        this.router.navigateByUrl('/');
        return;
        //this.ResetForm();
      }
      else {
        this.toasterService.Warning(resp.Status_Msg, 'error');
      }

    },  (err) => {
        alert('Error');
      });
   
    }
  }
  }
  }
  }
  }

  MeasureStrength(pass: string) {  
    let score = 0;  
    // award every unique letter until 5 repetitions  
    let letters = {};  
    for (let i = 0; i< pass.length; i++) {  
    letters[pass[i]] = (letters[pass[i]] || 0) + 1;  
    score += 5.0 / letters[pass[i]];  
    }  
    // bonus points for mixing it up  
    let variations = {  
    digits: /\d/.test(pass),  
    lower: /[a-z]/.test(pass),  
    upper: /[A-Z]/.test(pass),  
    nonWords: /\W/.test(pass),  
    };  
    let variationCount = 0;  
    for (let check in variations) {  
    variationCount += (variations[check]) ? 1 : 0;  
    }  
    score += (variationCount - 1) * 10;  
    return Math.trunc(score);  
    }  

}
